export enum JobType {
    DEVELOPER = 'DEVELOPER',
    TESTER = 'TESTER',
    PROJECT_MANAGER = 'PROJECT_MANAGER',
    HR = 'HR',
    QA = 'QA',
}
